/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const LineChart = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M3.5 2V20.5H22V22H2V2H3.5ZM21 5.93934L22.0607 7L16 13.0607L13.032 10.093L5.56056 18.4983L4.43944 17.5017L12.9679 7.90723L16 10.939L21 5.93934Z"
                        fill={color}
                    />
                </svg>
        );
    };
